import { t } from 'i18next';
import { ListColumnFilter } from '../../../Common/list-entities/ListColumnFilter';
import { OPERATORS, TYPES } from '../../../../common/list-utils';
import { DateCustom } from '../../../../lib/DateCustom';
import { getNext10Years } from '../utils/settlementUtils';

export const useSettlementFilters = (): ListColumnFilter[] => {
  return [
    {
      quick: true,
      name: 'ejercicio',
      type: TYPES.COMBOBOX,
      placeholder: t('Ejercicio'),
      operator: OPERATORS.YEAR,
      contextForCombobox: getNext10Years().map((y) => ({ text: y.toString(), key: y })),
    },
    {
      quick: true,
      name: 'periodo',
      type: TYPES.TYPE_DATE_YEAR_MONTH,
      placeholder: t('Periodo'),
      operator: OPERATORS.YEAR_MONTH,
      calendarProps: { isDayPickerVisible: false },
      isMonthSelector: true,
      formatDate: DateCustom.formatMonth,
      required: true,
    },
  ];
};
